<ng-container *ngFor="let input of group.inputs">
    <wuc-card class="coverage-card coverage-card--has-tag"
              [class.coverage-card--has-tag]="input?.featured"
              [class.coverage-card--disabled]="!input.acceptance"
              [insTooltip]="!input.acceptance ? 'Deze dekking is niet mogelijk in uw situatie' : null"
              [cardStyle]="selectedInputs[input?.id] ? 'quaternary' : !input?.acceptance ? 'secondary' : 'tertiary'"
              padding="medium">
        <div class="coverage-card__tag"
             [class.coverage-card__tag--active]="selectedInputs[input?.id]"
             *ngIf="input?.featured">Meest gekozen</div>
        <div class="coverage-card__header">
        <span class="coverage-card__header-title">
            {{ input?.data?.title }}
        </span>
            <div class="coverage-card__header-price">
                <span *ngIf="input?.price === 0" class="coverage-card__header-price-label">gratis</span>
                <ng-container *ngIf="input?.price > 0">
                    <wuc-price [price]="input?.price"></wuc-price>
                    <br/>
                    per maand
                </ng-container>

            </div>
        </div>
        <div class="coverage-card__body" *ngIf="input?.data?.body" [innerHTML]="input?.data?.body"></div>
        <ng-container slot="footerContent">
            <div class="coverage-card__footer">
                <wuc-button *ngIf="!selectedInputs[input?.id]" (buttonClick)="selectCoverage(input)" type="secondary"
                            [iconLeft]="!group?.single ? 'add' : null">
                    {{!group?.single ? 'Voeg toe' : 'Kiezen'}}
                </wuc-button>
                <wuc-button *ngIf="selectedInputs[input?.id]" (buttonClick)="deselectCoverage(input)" type="primary"
                            iconLeft="check-closed">
                    {{!group?.single ? 'Toegevoegd' : 'Gekozen'}}
                </wuc-button>
                <wuc-link type="secondary" (clicked)="displayInformation(input?.data)">Meer info</wuc-link>
            </div>
        </ng-container>
    </wuc-card>
</ng-container>
